/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Nav_TutorialsInputs */

const en_cad_nav_tutorials = /** @type {(inputs: Cad_Nav_TutorialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorials`)
};

/**
* | output |
* | --- |
* | "Tutorials" |
*
* @param {Cad_Nav_TutorialsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_nav_tutorials = /** @type {((inputs?: Cad_Nav_TutorialsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Nav_TutorialsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_nav_tutorials(inputs)
});
export { cad_nav_tutorials as "cad.nav.tutorials" }